import React, {useCallback, useRef, useState} from 'react'
import {Outlines, useGLTF} from '@react-three/drei'
import {INFO_PANEL_DATA, LINKEDIN_BOX_PROPS} from '../utils/constants.jsx'
import {useAppStore} from '../stores/store.js'
import * as THREE from 'three'
import {usePulsatingOutline} from '../hooks/usePulsatingOutline.jsx'
import {useThree} from '@react-three/fiber'
import {SelectionHover} from './SelectionHover.jsx'

export function LinkedInModel(props) {
    const {nodes, materials} = useGLTF('./models/linkedin.glb')
    const linkedinRef = useRef(null)
    const [hovered, setHovered] = useState(false)
    const {camera, size} = useThree()

    const outlineThickness = usePulsatingOutline(0.01, 0.03, 2); // Adjust values as needed

    const handleClick = useCallback((event) => {
        event.stopPropagation()

        if (!linkedinRef.current || !camera || !size.width || !size.height) {
            console.warn('Click skipped: Missing refs, handlers, or camera/size info.')
            return
        }

        const {focusOnObject, selectObject} = useAppStore.getState()

        // Get World Position
        const worldPos = new THREE.Vector3()
        linkedinRef.current.getWorldPosition(worldPos)

        const cameraFocusOffset = new THREE.Vector3(-3, 3, -5)
        focusOnObject(worldPos, cameraFocusOffset)
        selectObject(INFO_PANEL_DATA.linkedin.id)

    }, [camera, size])

    const handlePointerEnter = useCallback((e) => {
        e.stopPropagation()
        setHovered(true)
        document.body.style.cursor = 'pointer'
    }, [])

    const handlePointerOut = useCallback((e) => {
        e.stopPropagation()
        setHovered(false)
        document.body.style.cursor = 'default'
    }, [])

    return (
        <>
            <group {...props} dispose={null}>
                <group position={[2.599, 1.641, 2.546]}>
                    <mesh
                        geometry={nodes.linkedin_1.geometry}
                    >
                        <meshBasicMaterial color={materials.white.color}/>

                    </mesh>
                    <mesh
                        geometry={nodes.linkedin_2.geometry}
                    >
                        <meshBasicMaterial color={materials.blue.color}/>
                        <Outlines thickness={outlineThickness} color='white' screenspace={true}/>
                    </mesh>

                </group>
            </group>
            <mesh
                position={LINKEDIN_BOX_PROPS.position}
                scale={LINKEDIN_BOX_PROPS.scale}
                ref={linkedinRef}
                onPointerEnter={handlePointerEnter}
                onPointerOut={handlePointerOut}
                onClick={handleClick}
            >
                <boxGeometry/>
                <meshBasicMaterial
                    visible={false}
                    // color='blue'
                    // opacity={0.5}
                    // transparent={true}
                />
            </mesh>
            <SelectionHover
                objectRef={linkedinRef}
                hovered={hovered}
                cornerSize={0.5}
                padding={0.02}
            />
        </>
    )
}


useGLTF.preload('./models/linkedin.glb')

